import { Redirect, Route } from 'react-router-dom';

import { useCognito } from '@uptime/shared/providers/CognitoProvider';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthorized, isLoadingSession } = useCognito();

  if (isLoadingSession) return null;

  if (!isAuthorized) return <Redirect to="/login" />;

  return <Route {...rest} render={() => <Component {...rest} />} />;
};

export default PrivateRoute;
